const pageFlow = {
  title: 'Flow List',
  name: 'Name',
  status: 'Status',
  updateTime: 'Update time',
  description: 'Description',
  newFlow: "New Tool",
  type: "Type",
  updater: "Updater",
  deleteTitle: 'Delete the flow',
  deleteDescription: 'Are you sure to delete this flow?',
  add: {
    flowName: 'Flow Name',
    flowNameTooltip: 'The Tool name can only contain letters, digits, and underscores, and must start with a letter.',
    performanceDescription: 'Performance Description',
    noteDescription: 'Note Description',
    type: 'Type',
    title: 'Tool',
    msg: "A clear and descriptive name and description help LLM better understand the function that the flow does.",
    performanceDescriptionPlaceholder: "Please describe the calling scenarios for this Flow to help the LLM better understand it.",
    noteDescriptionPlaceholder: "Description of this flow tool",
    flowNamePlaceholder: 'Please enter the Tool Name',
  },
  flow: {
    form: {
      inputParameter: 'Input Parameter'
    }
  }
}

export default pageFlow
